export default __webpack_public_path__ + "static/media/servicetype_3d.d7df4048.png";